// Who to show under "Gig contacts" in the Next Gig Brief.
//
// People attached to the gig (collaborator_ids, or performing_member_ids on a
// band gig) come first, in the order they were added; anyone else whose name is
// written in the gig notes follows. Attached people are included even when they
// have no email or phone — being on the gig is the point, not being invitable.
export function gigContactsFor(gig, collaborators, notes) {
  const all = collaborators || [];
  const attachedIds = [...(gig?.collaborator_ids || []), ...(gig?.performing_member_ids || [])];
  const seen = new Set();
  const out = [];

  for (const id of attachedIds) {
    if (seen.has(id)) continue;
    const c = all.find((x) => x.collaborator_id === id);
    if (c) {
      seen.add(id);
      out.push(c);
    }
  }

  const text = (notes || "").toLowerCase();
  if (text) {
    for (const c of all) {
      if (c.name && !seen.has(c.collaborator_id) && text.includes(c.name.toLowerCase())) {
        seen.add(c.collaborator_id);
        out.push(c);
      }
    }
  }
  return out;
}
